"use strict";
// _partialFile.js

{
  //430px 未満は JS で viewport を固定する
  // =============================
  (function () {
    const viewport = document.querySelector('meta[name="viewport"]');

    function switchViewport() {
      const value = window.outerWidth > 430 ? "width=device-width,initial-scale=1" : "width=430";
      if (viewport.getAttribute("content") !== value) {
        viewport.setAttribute("content", value);
      }
    }
    addEventListener("resize", switchViewport, false);
    switchViewport();
  })();
}
